// extracted by mini-css-extract-plugin
export default {"title":"DietPlusInjection_title__tDtKU","readingInput":"DietPlusInjection_readingInput__--N0G","readingsRow":"DietPlusInjection_readingsRow__3kBjq"};